<div class="col-12 white-background common-border-radius" style="background-color: #fff;">
  <div class="grid">
    <div class="col-fixed">
      <h1 class="page-title c-m-7">Download</h1>
    </div>
    </div>
<div style="height: 90vh;">
  <div class="p-col" style="justify-content: center;display: flex;align-items: center;flex: auto;">
      <button pButton type="button" icon="fa fa-download" label="Download" (click)="downloadFile()"></button>
    </div>
</div>
</div>